// extracted by mini-css-extract-plugin
module.exports = {"container":"Root_container__3vbMt","content":"Root_content__3bIIj","buttonContent":"Root_buttonContent__2hqKG","info":"Root_info__1ZKJH"};